import { render, staticRenderFns } from "./Baner.vue?vue&type=template&id=bc9d5214&"
import script from "./Baner.vue?vue&type=script&lang=js&"
export * from "./Baner.vue?vue&type=script&lang=js&"
import style0 from "./Baner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports